var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content has-text-grey has-text-centered"},[(_vm.loading)?void 0:[_c('p',[_vm._v("データはありません")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }